import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import DatoImage from "~components/dato-image";
import meta from "~generated/meta.json";
import { Box, Container, Heading, Link, Stack, Text, useColorModeValue } from "@chakra-ui/react";
import NextLink from "next/link";
import { NextSeo } from "next-seo";

var HomePage = function HomePage(props) {
  var _data$site$favicon;

  var data = props.data;
  var variant = useColorModeValue("light", "dark");
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(NextSeo, {
      title: meta.site.seo.siteName
    }), /*#__PURE__*/_jsx(Container, {
      maxW: "4xl",
      p: [4, 8],
      children: /*#__PURE__*/_jsxs(Stack, {
        align: "center",
        spacing: 4,
        textAlign: "center",
        children: [/*#__PURE__*/_jsx(NextLink, {
          href: "/about",
          passHref: true,
          children: /*#__PURE__*/_jsx(Box, {
            _hover: {
              bgColor: "whiteAlpha.50"
            },
            as: "a",
            borderRadius: "full",
            maxW: "xs",
            overflow: "hidden",
            sx: {
              WebkitMaskImage: "-webkit-radial-gradient(white, black)",
              MozBackfaceVisibility: "hidden",
              WebkitBackfaceVisibility: "hidden",
              MozTransform: "translate3d(0, 0, 0)",
              WebkitTransform: "translate3d(0, 0, 0)"
            },
            transform: "auto-gpu",
            transitionDuration: "normal",
            transitionProperty: "common",
            transitionTimingFunction: "ease-out",
            children: /*#__PURE__*/_jsx(DatoImage, {
              data: (_data$site$favicon = data.site.favicon) === null || _data$site$favicon === void 0 ? void 0 : _data$site$favicon.responsiveImage
            })
          })
        }), /*#__PURE__*/_jsx(Heading, {
          size: "3xl",
          children: "Hey! I'm Rivaldi Putra."
        }), /*#__PURE__*/_jsx(Text, {
          fontSize: ["lg", "xl"],
          maxW: "2xl",
          children: meta.site.seo.fallback.description
        }), /*#__PURE__*/_jsx(Box, {
          h: 8
        }), /*#__PURE__*/_jsxs(Text, {
          pb: 8,
          children: ["Reach me via email at", " ", /*#__PURE__*/_jsx(Link, {
            href: "mailto:".concat(meta.about.email),
            variant: variant,
            children: meta.about.email
          }), ", or Twitter at", " ", /*#__PURE__*/_jsx(Link, {
            href: "https://twitter.com/".concat(meta.site.seo.twitterAccount),
            isExternal: true,
            variant: variant,
            children: meta.site.seo.twitterAccount
          }), "."]
        })]
      })
    })]
  });
};

export var __N_SSG = true;
export default HomePage;